import { CancelOrder } from "@/types/order-type";
import { CancelOrderCard } from "./CancelOrderCard";

export function CancelOrderList({ logs }: { logs: CancelOrder[] }) {
    if (!logs || logs.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-2 px-4 border-2 border-dashed border-slate-100 rounded-xl">
                <p className="text-sm text-slate-400">No cancellation history available.</p>
            </div>
        );
    }

    return (
        <div className="space-y-1 py-2">
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 px-1">
                Cancellation Log
            </h3>
            <div className="flex flex-col">
                {logs.map((log) => (
                    <CancelOrderCard key={log.id} log={log} />
                ))}
            </div>
        </div>
    );
}